import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CGV = () => {
  return (
    <div className="min-h-screen bg-black text-white/80">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        {/* Back button */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#C9A55C] hover:text-[#C9A55C]/80 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1 className="text-4xl font-serif font-bold text-white mb-8">
          Conditions Générales de Vente
        </h1>

        <div className="space-y-8 text-white/70 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">1. Objet</h2>
            <p className="mb-4">Les présentes Conditions Générales de Vente (CGV) encadrent la vente :</p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>d'abonnements donnant accès à des services numériques</li>
              <li>de services ponctuels réalisés par HELP'ADN</li>
              <li>de produits numériques ou outils vendus en achat unique</li>
            </ul>
            <p>Toute commande implique l'acceptation pleine et entière des présentes CGV.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">2. Produits – Achat unique</h2>
            <p className="mb-4">Les produits (packs, fichiers, modèles, outils, contenus numériques…) sont vendus une seule fois.</p>
            <p className="mb-4">L'accès est délivré immédiatement après paiement, sauf mention contraire.</p>
            <p>Aucun droit de rétractation ne s'applique (article L221‑28 du Code de la consommation).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">3. Services – Prestations ponctuelles</h2>
            <p className="mb-4">Les services (accompagnement, rédaction, création, interventions…) sont réalisés selon le descriptif fourni au client.</p>
            <p className="mb-4">Toute prestation commencée est due.</p>
            <p>Aucun remboursement n'est possible après exécution totale ou partielle du service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">4. Abonnements – Durée – Renouvellement</h2>
            <p className="mb-4">Les abonnements sont mensuels ou annuels selon l'option choisie.</p>
            <p className="mb-4">Ils se renouvellent automatiquement à échéance.</p>
            <p className="mb-4">Le client peut résilier à tout moment depuis son espace client.</p>
            <p className="mb-4">La résiliation prend effet à la prochaine échéance.</p>
            <p>Aucun remboursement prorata n'est effectué.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">5. Prix</h2>
            <p className="mb-4">Les prix sont indiqués en euros TTC.</p>
            <p>HELP'ADN peut modifier ses tarifs à tout moment, sans effet sur les achats déjà réalisés.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">6. Paiement</h2>
            <p className="mb-4">Les paiements sont effectués via :</p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>Stripe</li>
              <li>PayPal</li>
              <li>Carte bancaire</li>
              <li>Tout autre prestataire sécurisé</li>
            </ul>
            <p>HELP'ADN ne stocke aucune donnée bancaire.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">7. Exécution immédiate & absence de droit de rétractation</h2>
            <p className="mb-4">Conformément à l'article L221‑28 du Code de la consommation :</p>
            <ul className="list-disc list-inside mb-4 space-y-1">
              <li>les produits numériques délivrés immédiatement ne sont pas soumis au droit de rétractation</li>
              <li>les services exécutés immédiatement ne sont pas soumis au droit de rétractation</li>
              <li>les abonnements donnant accès immédiat au service ne sont pas soumis au droit de rétractation</li>
            </ul>
            <p className="p-4 bg-[#C9A55C]/10 border border-[#C9A55C]/30">
              <strong className="text-[#C9A55C]">En payant, le client renonce expressément à son droit de rétractation.</strong>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">8. Remboursements</h2>
            <p className="mb-4">Aucun remboursement n'est accordé après accès au produit ou au service, sauf :</p>
            <ul className="list-disc list-inside space-y-1">
              <li>double paiement</li>
              <li>erreur technique empêchant l'accès</li>
              <li>facturation manifestement erronée</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">9. Obligations du client</h2>
            <p className="mb-4">Le client s'engage à :</p>
            <ul className="list-disc list-inside space-y-1">
              <li>fournir des informations exactes</li>
              <li>ne pas partager son accès</li>
              <li>ne pas revendre les contenus</li>
              <li>respecter les CGU</li>
              <li>utiliser le service de manière conforme à la loi</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">10. Obligations de HELP'ADN</h2>
            <p className="mb-4">HELP'ADN s'engage à :</p>
            <ul className="list-disc list-inside space-y-1">
              <li>fournir l'accès aux produits achetés</li>
              <li>assurer la continuité du service (hors maintenance)</li>
              <li>intervenir en cas de problème technique</li>
              <li>exécuter les prestations commandées dans les délais annoncés</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">11. Disponibilité du service</h2>
            <p>HELP'ADN peut suspendre temporairement l'accès pour maintenance, mise à jour ou incident technique.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">12. Force majeure</h2>
            <p>HELP'ADN ne peut être tenu responsable en cas d'événement imprévisible et extérieur empêchant l'exécution du service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">13. Droit applicable</h2>
            <p className="mb-4">Les présentes CGV sont régies par le droit français.</p>
            <p>En cas de litige, les tribunaux français seront seuls compétents.</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default CGV;
